import { render } from "./Dashboard.vue?vue&type=template&id=193c723e"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "193c723e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('193c723e', __exports__)) {
    api.reload('193c723e', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=193c723e", () => {
    api.rerender('193c723e', render)
  })

}


export default __exports__